// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
import App from './App';

// const root = ReactDOM.createRoot(document.getElementById('broadcast-player-root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
import domReady from '@wordpress/dom-ready';
import { createRoot } from '@wordpress/element';

// --- DEVELOPMENT MOCK ---
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
if (isDevelopment && !window.broadcastPlayerData) {
    const urlParams = new URLSearchParams(window.location.search);
    window.broadcastPlayerData = {
        seriesJSON: null, // Set to a JSON string or object to test SeriesPlayer
        restUrl: 'https://insight.org/wp-json/wp/v2/',
        nonce: '',
        debug: true,
        postId: 0,
        isLoggedIn: false,
        language: urlParams.get('lang') || 'en-US', // Defaults to English, use ?lang=es for Spanish
        prerollAdUrl: '',
        postrollAdUrl: '',
        pauseAdImageUrl: '',
        pauseAdClickUrl: '',
        fallbackImageUrl: '',
    };
    console.log('🛠️ Dev Mode: Mocked broadcastPlayerData with language:', window.broadcastPlayerData.language);
}
// --- END MOCK ---

domReady(() => {
    const container = document.getElementById('broadcast-player-root');
    if (!container) {
        // Not on a page that includes the broadcast player shortcode; safely skip.
        return;
    }

    // Reuse existing root if already created to prevent duplicate mounting
    let root = container._reactRootContainer || null;
    if (!root) {
        root = createRoot(container);
        container._reactRootContainer = root;
    }
    root.render(<App />);
});
